const ONES = ["", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "ten", "eleven", "twelve", "thirteen", "fourteen", "fifteen", "sixteen", "seventeen", "eighteen", "nineteen"];
const TENS = ["", "", "twenty", "thirty", "forty", "fifty", "sixty", "seventy", "eighty", "ninety"];

function two(n) {
  return n < 20 ? ONES[n] : TENS[Math.floor(n / 10)] + (n % 10 ? " " + ONES[n % 10] : "");
}

function three(n) {
  const h = Math.floor(n / 100);
  const r = n % 100;
  return [h ? ONES[h] + " hundred" : "", r ? two(r) : ""].filter(Boolean).join(" ");
}

// Indian numbering: crore, lakh, thousand
export function inWords(n) {
  if (n === 0) return "zero";
  const crore = Math.floor(n / 10000000);
  const lakh = Math.floor((n % 10000000) / 100000);
  const thousand = Math.floor((n % 100000) / 1000);
  const rest = n % 1000;
  return [
    crore ? inWords(crore) + " crore" : "",
    lakh ? two(lakh) + " lakh" : "",
    thousand ? two(thousand) + " thousand" : "",
    rest ? three(rest) : "",
  ].filter(Boolean).join(" ");
}

export function rupeesInWords(amount) {
  const v = Math.round(Number(amount || 0) * 100);
  const rupees = Math.floor(v / 100);
  const paise = v % 100;
  let s = `${inWords(rupees)} ${rupees === 1 ? "rupee" : "rupees"}`;
  if (paise) s += ` and ${inWords(paise)} paise`;
  return s;
}

export const paymentPhrase = (amount) => `Payment received: ${rupeesInWords(amount)}`;

export const voiceSupported = () => typeof window !== "undefined" && "speechSynthesis" in window;

export function speak(text, volume = 1) {
  if (!voiceSupported()) return false;
  try {
    const u = new SpeechSynthesisUtterance(text);
    u.lang = "en-IN";
    u.rate = 0.95;
    u.volume = Math.max(0, Math.min(1, Number(volume)));
    const voices = window.speechSynthesis.getVoices();
    const v = voices.find((x) => x.lang === "en-IN") || voices.find((x) => x.lang?.startsWith("en"));
    if (v) u.voice = v;
    window.speechSynthesis.speak(u);
    return true;
  } catch {
    return false;
  }
}

export function getVoiceSettings() {
  return {
    enabled: localStorage.getItem("vp_voice_enabled") !== "false",
    volume: parseFloat(localStorage.getItem("vp_voice_volume") ?? "1"),
    privacy: localStorage.getItem("vp_voice_privacy") === "true",
  };
}

export function saveVoiceSettings(s) {
  localStorage.setItem("vp_voice_enabled", String(s.enabled));
  localStorage.setItem("vp_voice_volume", String(s.volume));
  localStorage.setItem("vp_voice_privacy", String(s.privacy));
}
